<template>
    <div>
        <div class="d-flex align-items-end">
            <h4>Preguntas de la denuncia</h4>
            <div class="flex-grow-1"></div>
            <SettingTypeDenounce></SettingTypeDenounce>
        </div>
        <hr>
        <SettingListQuestions/>
    </div>
</template>
<script>

import SettingTypeDenounce from './DenounceSetting/Setting-type-denounce.vue'
import SettingListQuestions from './DenounceSetting/Setting-list-questions.vue'
export default {
    name: 'DenounceSetting',

    components: {
        SettingTypeDenounce,
        SettingListQuestions,
    }
}
</script>

<style scoped>
h4 {
    margin-bottom: 0;
}
</style>